import React from 'react';

type AlertsDialogDescriptionProps = {
    dialogSummaryText?: string;
};

const AlertsDialogDescription = (props: AlertsDialogDescriptionProps) => {
    const { dialogSummaryText } = props;
    return (
        <div data-testid="alertsdialogdescription" style={{ display: 'flex', marginTop: '8px', marginBottom: '8px' }}>
            <div style={{ flex: 1, marginTop: '8px' }}>
                {dialogSummaryText ??
                    'One or more alerts have been raised for this message. For more details, please select an item from the list below.'}
            </div>
        </div>
    );
};

export default AlertsDialogDescription;
